import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { type EnhancedResDocumentOCRResultQuery } from '@/lib/queries/business/v1/ocr/result/types'

import { SESSION_STORAGE_KEY } from '../constants'

export interface DocumentOCRResultStore {
  ocrResults: Record<number, EnhancedResDocumentOCRResultQuery>
  setOCRResult: (taskId: number, formState: EnhancedResDocumentOCRResultQuery) => void
  getCurrentOCRResult: (taskId?: number) => EnhancedResDocumentOCRResultQuery | undefined
  clear: () => void
}

/**
 * @description
 *
 * This is a source of truth of UIs for document OCR results data.
 *
 */
export const useDocumentOCRResultStore = create<DocumentOCRResultStore>()(
  persist(
    (set, get) => ({
      ocrResults: {},
      setOCRResult: (taskId, formState) =>
        set((state) => ({ ocrResults: { ...state.ocrResults, [taskId]: formState } })),
      getCurrentOCRResult: (taskId) => (taskId ? get().ocrResults[taskId] : undefined),
      clear: () => set({ ocrResults: {} }),
    }),
    {
      name: SESSION_STORAGE_KEY.documentOCRResultStore,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
